import { useRouter } from "next/router";
import React from "react";
import { E, type io, pipe } from "../prelude";

export function useQueryParams<I, O>(decoder: io.Decoder<I, O>) {
  const router = useRouter();
  return React.useMemo(() => {
    const validation = decoder.decode(router.query as any);
    return pipe(
      validation,
      // FIXME: proper error handling,
      E.mapLeft((_) => {
        return "Could not parse query params";
      }),
    );
  }, [decoder, router.query]);
}
